export const HD_STATUS: Record<string, { label: string; color: string }> = {
  novy: { label: 'Nový', color: '#0071e3' },
  otevreny: { label: 'Otevřený', color: '#cc7700' },
  ceka_na_uziv: { label: 'Čeká na uživatele', color: '#5b3f96' },
  vyreseno: { label: 'Vyřešeno', color: '#2ca84b' },
  zavreno: { label: 'Zavřeno', color: '#6c6c70' },
  spam: { label: 'Spam', color: '#c82b23' },
};
